import styled from '@emotion/styled'
import Modal from './Modal'
import { Drawer } from '@mui/material'
import Box from '@mui/material/Box'

export const StyledModal = styled(Modal)``

export const Content = styled(Box)`
  min-width: 431px;
  min-height: 306px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 20px;
`

export const StyledDrawer = styled(Drawer)`
  & > div {
    background: linear-gradient(180deg, #d13e43 0%, #a83438 100%);
  }
`
